import requiredFieldConfigRaw from '../../data/requiredFieldConfig';
import SubmitLoanPageRenderer from './SubmitLoanPageRenderer';

const GuidelineExceptionValidate = () => {
    const config = requiredFieldConfigRaw.Pages.find(
        (p) => p.Page === 'Request Guideline Exception'
    );

    return (
        <SubmitLoanPageRenderer
            pageName="Request Guideline Exception"
            config={config}
            redirectPage="Request Guideline Exception"
        />
    );
};

export default GuidelineExceptionValidate;
